export default __webpack_public_path__ + "components/page-header/static/icon-home-95a2248e41e55d774391cadca2cab975.svg";